import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../components/seo"

const title = "Home Page"

const IndexPage = ({ data }) => {
  // Get all images from query
  const images = data.images.edges
  // Select a random index
  const randomIndex = Math.floor(Math.random() * images.length)
  // Get the gatsbyImageData object for the random image
  const randomImage = images[randomIndex].node.childImageSharp.gatsbyImageData
  const name = images[randomIndex].node.relativePath.split("/")

  return (
    <Layout pageTitle="Bryan Leister">
      <GatsbyImage
        image={randomImage}
        alt={name[1]}
        layout="constrained"
        height={300}
      />
      <p>
        <Link
          to={"/recent-work/" + name[1]}
          style={{ marginLeft: "0" }}
          aria-label={
            "image of " +
            name[2]
              .replace(/^.{10}|-/g, " ")
              .replace(/.jpg/, "")
              .replace(/_A|_W/gi, "") +
            " linking to the recent work page"
          }
        >
          {name[1]}
        </Link>
        {" : " +
          name[2]
            .replace(/^.{10}|-/g, " ")
            .replace(/.jpg/, "")
            .replace(/_A|_W/gi, "")}
      </p>
    </Layout>
  )
}

export const pageQuery = graphql`
  query ImagesForGallery {
    images: allFile(
      filter: {
        name: { regex: "/^[0-9]{4}/i" }
        childImageSharp: { fluid: { aspectRatio: { gt: 1.3 } } }
        relativeDirectory: { ne: "images/applications" }
      }
      limit: 30
      sort: { name: DESC }
    ) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              transformOptions: { fit: COVER, cropFocus: ATTENTION }
            )
          }
          relativePath
        }
      }
    }
  }
`
export const Head = () => <Seo title={title} />
export default IndexPage
